import styled, { css } from 'styled-components';
import { FormControl } from '@bechtel/gds';
interface FormControlStyledProps {
  label: string;
  isEnabled: boolean;
}
export const FormControlStyled = styled(FormControl)<FormControlStyledProps>`
  flex-grow: 1;
  width: 160px;

  ${({ theme }) => css`
    color: ${theme.colors.bechtel.blue[800]};
    border: solid 1px ${theme.colors.bechtel.blue[800]};
    border-radius: ${theme.spacings[200]};
  `}
  ${(props) =>
    props.isEnabled
      ? css`
          opacity: 1;
          pointer-events: all;
        `
      : css`
          opacity: 0.4;
          pointer-events: none;
        `}
`;
